module.exports = function () {
  return "<div class=\"poker-board\" id=\"deal\"></div>";
};